module.exports = __webpack_public_path__ + "public/images/socializing.7ab601e09139058ef9be0899ebb9e37a.png";